var _style, _path, _polygon, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBang(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF0000;}\r\n\t.st1{fill:#F7931E;}\r\n\t.st2{fill:#FFFF00;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st0",
    d: "M243.8,139.2L386.1,9.3L322.3,185l177.7,6.2l-147.5,56.5l124,123.7l-112.4-26.6l37.3,136.7 l-126-126L221.2,500l-18.1-157.9L77.7,481c0,0,61-174,62.7-175.1S0,273.1,0,273.1L124,233L21.7,109.3l136.7,50.3L190.7,0 L243.8,139.2z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2_",
    className: "st1",
    points: "278.3,165.4 418.4,121.2 330.8,216.1 415.5,260.1 307.6,282.2 352.8,368.6 257.9,300.8  181.1,416.6 186.7,294.6 82.8,324 135.9,257.9 41.5,203.6 138.1,194.6 128,90.1 196.9,151.7 250,58.4 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3_",
    className: "st2",
    points: "229.9,183.9 298.6,141.5 275.4,196.3 328,199.1 285,226.2 347.2,292.9 263,270.9  258.5,347.7 229.9,273.1 168.1,324 198.6,240.9 108.7,209.9 198,213.2 178.8,119.5 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBang);
export default __webpack_public_path__ + "static/media/bang.9c13b2db2db573e87a5382681e53458f.svg";
export { ForwardRef as ReactComponent };